import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '~/utils/redux/store';
import { StorageEnum } from '~/utils/enum/base';
import { handleLogin } from './authThunk';
import { IUserProfile } from '~/utils/interface/account';

export interface AuthState {
  accessToken?: string;
  user?: IUserProfile;
}

const initialState: AuthState = {};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    handleLogout() {
      localStorage.removeItem(StorageEnum.ACCESS_TOKEN);
    },
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleLogin.pending, (state) => {})
      .addCase(handleLogin.fulfilled, (state, action) => {})
      .addCase(handleLogin.rejected, (state) => {});
  },
});

export const authActions = authSlice.actions;

export const selectUser = (state: RootState) => state.auth.user;
export const selectAccessToken = (state: RootState) => state.auth.accessToken;

const authReducer = authSlice.reducer;
export default authReducer;
